<template>
  <div class="guahaojilu">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="list.length ? '没有更多了' : ''"
      @load="onLoad"
    >
      <p class="tips">* 10天内请勿退号满3次(不包含停诊退号)，3个月内请勿爽约满3次，否则将计入预约限制名单</p>
      <div v-for="item in list" :key="item.id" class="gj-list" @click="toDetail(item.id)">
        <div class="list-item">
          <span class="item-title">挂号状态：</span>
          <span class="item-value" :class="{blue: item.status === 2}">{{ item.status | status }}</span>
        </div>
        <div class="list-item">
          <span class="item-title">就诊时间：</span>
          <span class="item-value">{{ `${item.day} ${item.startTime}~${item.endTime}` }}</span>
        </div>
        <div class="list-item">
          <span class="item-title">挂号时间：</span>
          <span class="item-value">{{ item.registerTime }}</span>
        </div>
        <div class="list-item">
          <span class="item-title">挂号科室：</span>
          <span class="item-value">{{ item.deptName }}</span>
        </div>
        <div class="list-item" style="margin-left:11px">
          <span class="item-title">就诊人名称：</span>
          <span class="item-value">{{ item.patientName }}</span>
        </div>
      </div>
    </van-list>
    <no-data v-if="!loading && !list.length" />
  </div>
</template>

<script>
import noData from '../../components/noData.vue'
export default {
  name: 'Guahaojilu',
  components: { noData },
  filters: {
    status: (val) => {
      switch (val) {
        case 0:
          return '已取消'
        case 1:
          return '已挂号'
        case 2:
          return '已预约'
        case 3:
          return '已失效'
        default:
          return ''
      }
    }
  },
  data() {
    return {
      patientId: '',
      list: [],
      current: 1,
      pageSize: 10,
      loading: false,
      finished: false
    }
  },
  /* watch: {
    '$route': {
      handler: function(to, from) {
        if (from && from.path !== '/guahaoxiangqing') {
          Object.assign(this.$data, this.$options.data())
          this.ageCreated()
        }
      }
    }
  }, */
  created() {
    this.ageCreated()
  },
  mounted() {},
  methods: {
    ageCreated() {
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo) {
        this.patientId = JSON.parse(userInfo).id
        this.getregisterPage()
      }
    },
    getregisterPage() {
      this.loading = true
      const obj = {
        current: this.current,
        size: this.pageSize,
        patientIdList: this.patientId,
        registerType: 1
      }
      this.$Apis.registerPage(obj).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.list = [...this.list, ...res.data.list]
          this.finished = (res.data.totalPage === 0 || this.current === res.data.totalPage)
        } else {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    onLoad() {
      this.current++
      this.getregisterPage()
    },
    toDetail(id) {
      this.$router.push(`/guahaoxiangqing?id=${id}`)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.guahaojilu{
  .gj-list {
    padding: 0;
    margin: 10px 0;
  }
  .item-title{
    display: inline-block;
    min-width: 1rem;
    text-align: right;
  }
  .blue{
    color: #2B8CFF;
  }
  .tips {
    padding: 0 10px;
    font-size: 16px;
    line-height: 1.5;
    color: red;
  }
}
</style>
